export class BookingResults{
    constructor(
    public id: number,
    public date: string,
    public error: string,
    public succeeded: boolean
  ) {}
}